import React, { useEffect, useState } from "react";
import "./Reg.scss";
import "../Landing.scss";
import "../ln.scss";
import { withTranslation } from "react-i18next";
import axios from "axios";
import url from "../../../url.json";
import headers from "../../../config/headers";
import dateFormat from "dateformat";
import { Empty, Pagination } from "antd";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

function RegulLand({ t }) {
  const lan = useSelector((state) => state.langReducer);
  const [datas, setDatas] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    axios
      .get(url.url + `/regulation?page=${page}`, { headers: headers() })
      .then((res) => {
        setDatas(res.data.data);
      })
      .catch((err) => {
        if (err.response?.status == 404) window.location = "/404";
        else toast.error(err.response?.data?.error || t("Something went wrong"));
      })
      .finally(() => setLoading(false));
  }, [lan.value, page]);

  const handlePage = (e) => {
    setPage(e);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const items = datas?.result || [];

  return (
    <div className="landing-reg ln">
      <Helmet>
        <meta charSet="utf-8" />
        <title data-rh="true">Vis Nefrit | {t("Regulations")}</title>
      </Helmet>

      <div className="landing-reg__hero">
        <div className="landing-reg__container">
          <span className="ln-eyebrow">{t("ln_ql_docs_text")}</span>
          <h1 className="landing-reg__title">{t("Regulations")}</h1>
          <p className="landing-reg__text">{t("ln_reg_docs_text")}</p>
        </div>
      </div>

      <div className="landing-reg__container">
        <div className="landing-reg__list">
          {loading ? (
            [0, 1, 2].map((i) => <div key={i} className="landing-reg__box landing-reg__box_skeleton" />)
          ) : items.length ? (
            items.map((res, i) => (
              <div className="landing-reg__box" key={res.id ?? i}>
                <span className="landing-reg__icon" aria-hidden="true">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z" /><path d="M14 3v5h5M9 13h6M9 17h4" /></svg>
                </span>
                <div className="landing-reg__right">
                  <a
                    className="landing-reg__right-title"
                    href={res.file}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {res.title}
                  </a>
                  <span className="landing-reg__date">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 11h18" /></svg>
                    {dateFormat(res.date, "dd.mm.yyyy")}
                  </span>
                </div>
                <span className="landing-reg__action ln-btn ln-btn_outline" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 4v12M6 10l6 6 6-6M5 20h14" /></svg>
                  {t("Download")}
                </span>
              </div>
            ))
          ) : (
            <div className="landing-reg__empty">
              <Empty description={t("No data")} />
            </div>
          )}
        </div>

        {datas?.pagination?.total_pages > 1 ? (
          <div className="landing-reg__pagin">
            <Pagination
              current={page}
              pageSize={datas.pagination.per_page}
              total={datas.pagination.total}
              showSizeChanger={false}
              onChange={handlePage}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
export default withTranslation()(RegulLand);
